import React from "react";
import { AddCardZone } from "../Cards/AddCardZone";
import { useHover } from "../HoverContext";
import { NodeActions } from "../NodeActions";
import {  HoverLabel, moveNodeAction } from "../Renderer";
import { useSelection } from "../SelectionContext";
import { CardRenderer } from "./CardRenderer";


export function ContainerRenderer({ container, page, setPage,section }) {
  const { selectedNodeId, setSelectedNodeId } = useSelection();
  const { hoverNodeId, setHoverNodeId } = useHover();

  const isSelected = selectedNodeId === container.id;
  const isHover = hoverNodeId === container.id;

  const style = {
    display: "flex",
   
    outline: isSelected
      ? "2px solid #1A73E8"
      : isHover
      ? "2px dashed rgba(26,115,232,0.45)"
      : "none",
    outlineOffset: 2,
    cursor: "pointer",
    position: "relative",
    padding: "15px",
  };
const sp = container.styles?.custom?.spacing || {};

style.marginTop = sp.marginTop;
style.marginRight = sp.marginRight;
style.marginLeft = sp.marginLeft;

style.paddingTop = sp.paddingTop;
style.paddingRight = sp.paddingRight;
style.paddingLeft = sp.paddingLeft;
  return (
    <div
     draggable
  onDragStart={(e) => {
    e.dataTransfer.setData("nodeId", container.id);
    e.dataTransfer.setData("type", "container");
  }}
  onDragOver={(e) => e.preventDefault()}
  onDrop={(e) => {
    const sourceId = e.dataTransfer.getData("nodeId");
    moveNodeAction(sourceId, container.id,setPage); // We'll implement this smartly
  }}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        setSelectedNodeId(container.id);
      }}
      onMouseEnter={() => setHoverNodeId(container.id)}
      onMouseLeave={() => {if (selectedNodeId !== container.id) setHoverNodeId(null);}}
    >
      <HoverLabel id={container.id} />

      <NodeActions nodeId={container.id} page={page} setPage={setPage} />

      {container.cards.map((card,index) => (
        <React.Fragment key={card?.id}>
            <AddCardZone
            
      sectionId={section?.id}
      containerId={container?.id}
      index={index}
       page={page} setPage={setPage}
    />
<CardRenderer
          key={card.id}
          card={card}
          page={page}
          setPage={setPage}
          section={section}
          container={container}
        />
        
    {index === container.cards.length - 1 && (
      <AddCardZone
        sectionId={section?.id}
        containerId={container.id}
        index={index + 1}
         page={page} setPage={setPage}
      />
    )}
   </React.Fragment>
        
      ))}
    </div>
  );
}
